const appBarTitleTextSize = { xs: 13, sm: 14, md: 10, lg: 16, xl: 14 }

export const appBarStyle = (windowSize, isRTL, theme) => ({
  appBarItemContainer: {
    display: 'flex',
    // flexDirection: 'column',
    textDecoration: 'none',
    zIndex: 1300,
    height: '100%',
    '& .chosenText, .chosenText~.downArraow': {
      fontWeight: 'bold',
      color: theme.custom.toolbarAccentStop2
    },
    '&:hover': {
      '& .MuiIconButton-root, svg': {
        fontWeight: 'bold',
        color: theme.custom.toolbarAccentStop2
      }
    }
  },
  notificationUpdateContainerPopper: {
    zIndex: '1400 !important'
  },
  appBarHrefContainer: {
    display: 'flex',
    flex: 1,
    textDecoration: 'none',
    justifyContent: 'center',
    cursor: 'pointer',
    height: '100%'
  },
  appBarItemText: {
    display: 'flex',
    flexDirection: 'row',
    fontFamily: 'OpenSansHebrew',
    // toolbarText is 0.87-alpha black in light mode, not pure black — branch so light
    // mode stays byte-identical to the pre-migration literal.
    color: theme.palette.type === 'dark' ? theme.custom.toolbarText : '#000',
    textTransform: 'none',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    height: '100%',
    fontSize: appBarTitleTextSize[windowSize],
    borderRadius: 0,
    flex: 1,
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  appBarItemIcon: {
    color: theme.palette.type === 'dark' ? theme.custom.toolbarText : '#000',
    textTransform: 'none',
    fontSize: 26,
    borderRadius: 0,
    fontFamily: 'pulseemicons',
    '& svg': {
      color: theme.palette.type === 'dark' ? theme.custom.toolbarText : '#000'
    },
    '&:hover': {
      '& svg': {
        color: theme.custom.toolbarAccentStop2
      }
    },
    '& .header-whatsapp-icon': {
      width: '24px',
      height: '24px',
      // marginBottom: '4px',
    },
  },
  appBarItemBorder: {
    borderBottom: `1px solid ${theme.custom.toolbarBorder}`,
    // marginInline: 15
  },
  appBarItemDoubleArrowIcon: {
    marginInlineEnd: '0.5em',
    transform: isRTL ? 'rotate(0deg)' : 'rotateY(180deg)'
  },
  appBarItemArrow: {
    color: theme.palette.type === 'dark' ? theme.custom.toolbarText : 'black',
    alignSelf: 'center',
    fontSize: 21,
    marginTop: 4,
    marginLeft: -6
  },
  appBarItemPaper: {
    borderRadius: 0,
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10
  },
  appBarItemPaperBottom: {
    height: 6.09,
    width: '100%',
    background: `linear-gradient(90deg, ${theme.custom.toolbarAccentStop1} 1.31%, ${theme.custom.toolbarAccentStop2} 33.07%, ${theme.custom.toolbarAccentStop3} 134.74%)`,
    borderBottomLeftRadius: 100,
    borderBottomRightRadius: 100
  },
  appBarItemMenuItem: {
    fontSize: 14,
    fontFamily: 'OpenSansHebrew-Bold',
    alignSelf: 'center',
    textDecoration: 'none',
    color: theme.palette.type === 'dark' ? theme.custom.toolbarText : '#000',
    whiteSpace: 'break-spaces',
    '& svg': {
      fontSize: 17,
      color: theme.custom.toolbarTextSecondary,
      paddingRight: isRTL ? '0px !important' : '10px !important',
      paddingLeft: isRTL ? '10px !important' : '0px !important',
    },
    '&.active': {
      background: `linear-gradient(90deg, ${theme.custom.toolbarAccentStop1} 1.31%, ${theme.custom.toolbarAccentStop2} 33.07%, ${theme.custom.toolbarAccentStop3} 134.74%)`,
      color: theme.custom.toolbarAccentContrast,
      '& svg': {
        color: theme.custom.toolbarAccentContrast,
      },
    },
    '&:hover': {
      background: `linear-gradient(90deg, ${theme.custom.toolbarAccentStop1} 1.31%, ${theme.custom.toolbarAccentStop2} 33.07%, ${theme.custom.toolbarAccentStop3} 134.74%)`,
      color: theme.custom.toolbarAccentContrast,
      // border: 'none',
      '& svg': {
        color: theme.custom.toolbarAccentContrast,
      },
    }
  },
  appBarItemMenuRoot: {
    '&:hover': {
      backgroundColor: theme.custom.toolbarHoverBg
    }
  },
  pulseemAppBarLogo: {
    background: `linear-gradient(90deg, ${theme.custom.toolbarAccentStop1} 1.31%, ${theme.custom.toolbarAccentStop2} 33.07%, ${theme.custom.toolbarAccentStop3} 134.74%)`,
    borderRadius: 0,
    height: '100%',
    '&.logo': {
      padding: isRTL ? '15px 15px 15px 0px' : '15px 0px 15px 15px',
      marginLeft: isRTL ? 0 : '-24px',
      marginRight: isRTL ? '-24px' : 0,
      borderBottomLeftRadius: isRTL ? 0 : 40,
      borderBottomRightRadius: isRTL ? 40 : 0,
      '& svg': {
        padding: '0 28px'
      }
    }
  },
  appBar: {
    maxWidth: 'calc(100vw - 56px)',
    backgroundColor: `${theme.custom.toolbarBackground} !important`,
    zIndex: 50000000,
    boxShadow: '0px 1px 10px 4a4a4aab',
    height: 62.78,
    borderBottomLeftRadius: 40,
    borderBottomRightRadius: 40
  },
  appBarLogo: {
    marginInlineEnd: '1vw',
    width: windowSize === 'xs' ? 125 : 130,
    alignSelf: 'center',
    paddingLeft: 10,
    paddingRight: 10,
  },
  appBerSpace: {
    display: 'flex',
    flex: 1
  },
  appBarUsername: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-end',
    fontSize: 16,
    fontFamily: 'OpenSansHebrew-Bold'
  },
  appBarAfterTollbarContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'row',
    alignItems: 'center',
    height: '100%',
    '& .settingsContainer': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      '& .MuiButtonBase-root': {
        fontWeight: 600
      },
      '& .settingsBorder': {
        background: `linear-gradient(90deg, ${theme.custom.toolbarAccentStop1} 0%, ${theme.custom.toolbarAccentStop2} 23.8%, ${theme.custom.toolbarAccentStop3} 100%)`,
        width: 1.5,
        height: 24
      },
      '& svg': {
        color: theme.custom.toolbarAccentStop1
      }
    },
    '&>div': {
      '&:nth-child(1)': {
        '&>div': {
          padding: '0 10px'
        }
      },
    }
  },
  appBarSettingIcon: {
    width: 25
  },
  appBarQuestionIcon: {
    fontWeight: 'bold',
    fontSize: 27,
    textTransform: 'none'

  },
  appBarBorder: {
    backgroundColor: 'none',
    height: 0
  },
  phoneAppBarPaperContainer: {
    zIndex: 99999,
    boxSizing: 'border-box',
    top: 3,
    width: '100%',
    left: -7,
    padding: '0 75px',
    "@media screen and (max-width: 540px)": {
      padding: 0
    }
  },
  phoneAppBarContainer: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    maxWidth: '100%'
  },
  phoneAppBarButton: {
    color: theme.palette.type === 'dark' ? theme.custom.toolbarText : '#000',
    textTransform: 'none',
    fontSize: 28,
    borderRadius: 0,
    "&:hover": {
      color: theme.custom.toolbarAccentAlt
    }
  },
  phoneAppBarPaper: {
    padding: 20,
    borderRadius: 0,
    marginTop: 3
  },
  phoneAppBarPopupContainer: {
    padding: 20,
    border: `2px solid ${theme.custom.toolbarAccentAlt}`,
    borderRadius: 5,
    alignSelf: 'center'
  },
  phoneAppBarCloseContainer: {
    backgroundColor: theme.custom.toolbarAccentAlt,
    justifyContent: 'center',
    position: 'absolute',
    borderRadius: 50,
    display: 'flex',
    height: 20,
    width: 20,
    left: 86,
    top: 15,
    "@media screen and (max-width: 540px)": {
      left: 12
    }
  },
  phoneAppBarCloseIcon: {
    fontSize: 13,
    alignSelf: 'center'
  },
  phoneAppBarItemContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },
  phoneAppBarItemIcon: {
    fontFamily: 'pulseemicons',
    textAlign: 'center',
    fontSize: 23,
    '& .header-whatsapp-icon': {
      width: '24px',
      height: '24px',
      fill: theme.palette.type === 'dark' ? theme.custom.toolbarText : 'black',
    },
  },
  mobileLanguageBtn: {
    fontSize: appBarTitleTextSize[windowSize],
    color: theme.custom.toolbarAccentContrast
  },
  tokenAppBarLogo: {
    borderRadius: 0,
    height: '100%',
    '&.logo': {
      padding: isRTL ? '15px 15px 15px 0px' : '15px 0px 15px 15px',
      marginLeft: isRTL ? 0 : '-24px',
      marginRight: isRTL ? '-24px' : 0,
      borderBottomLeftRadius: isRTL ? 0 : 40,
      borderBottomRightRadius: isRTL ? 40 : 0,
      '& svg': {
        padding: '0 28px'
      }
    }
  },
})